module.exports = __webpack_public_path__ + "media/assets/community/faria-logo-238a83ce199737eeee83db8a4eb09982327ddb694cb91841a278604ae64a28dc.png";